/* eslint-disable @typescript-eslint/no-explicit-any */
import { LoanApplicationOfferResponse, PayloadRequestColoneApplication, PayloadRequestPatchOffer } from "@interfaces/MarketPlace";
import { baseApi } from "./baseApi";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const noAuthBaseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_URL_API,
});

const marketPlaceApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    patchOferSelected: build.mutation<any, { id_sol: string; id_offer: string; data: PayloadRequestPatchOffer }>({
      query: ({ id_sol, id_offer, data }) => ({
        url: `solicitudes/${id_sol}/ofertas/${id_offer}`,
        method: "PATCH",
        body: data,
      }),
    }),
    getOffers: build.query<LoanApplicationOfferResponse[], { id_sol: string }>({
      query: ({ id_sol }) => `solicitudes/${id_sol}/ofertas`,
      transformResponse: (response: {
        code: string;
        message: string;
        errors: any[];
        data: {
          page: number;
          size: number;
          total: number;
          total_pages: number;
          data: LoanApplicationOfferResponse[];
        };
      }) => {
        return response.data?.data || [];
      },
    }),
    postCloneApplication: build.mutation<
      any,
      { application_id: string; data: PayloadRequestColoneApplication; accessToken?: string }
    >({
      queryFn: async ({ application_id, data, accessToken }, api, extraOptions, baseQuery) => {
        const request = {
          url: `solicitudes/${application_id}/transfer`,
          method: "POST" as const,
          body: data,
        };

        if (accessToken) {
          return noAuthBaseQuery(
            {
              ...request,
              headers: {
                authorization: `Bearer ${accessToken}`,
              },
            },
            api,
            extraOptions,
          );
        }

        return baseQuery(request);
      },
    }),
  }),
});

export const { usePatchOferSelectedMutation, useLazyGetOffersQuery, usePostCloneApplicationMutation } = marketPlaceApi;
